import axios from "utils/axiosInstance";
import { PaymentRefundRequestBody } from "./type";

export const bulkPaymentRefund = (requestBody: PaymentRefundRequestBody) => {
  return axios.post("/internal-tool/v1/order-payment/refund", requestBody);
};
